var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilterFunnel = function SvgFilterFunnel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1677FF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1.516 2.528C1.012 1.964.76 1.683.751 1.443a.667.667 0 0 1 .241-.54C1.177.75 1.555.75 2.312.75h9.895c.756 0 1.134 0 1.319.153.16.132.25.332.241.54-.01.24-.261.521-.765 1.085L9.197 6.78c-.1.112-.15.168-.186.232a.667.667 0 0 0-.07.181c-.015.072-.015.147-.015.298v3.565c0 .13 0 .195-.021.252a.334.334 0 0 1-.089.13c-.044.04-.105.064-.226.113l-2.266.906c-.245.098-.368.147-.466.127a.334.334 0 0 1-.21-.142c-.056-.084-.056-.216-.056-.48V7.491c0-.15 0-.226-.016-.298a.667.667 0 0 0-.069-.18 1.42 1.42 0 0 0-.186-.233L1.516 2.528Z"
  })));
};
export default SvgFilterFunnel;